import { createAuthClient } from 'better-auth/react';
import { expoClient } from '@better-auth/expo/client';
import * as Linking from 'expo-linking';
import * as SecureStore from 'expo-secure-store';
import { Platform } from 'react-native';
import { NEON_AUTH_URL, API_BASE_URL } from '../utils/constants';

const isWeb = Platform.OS === 'web';

/**
 * On native, every fetch to Neon Auth needs an Origin header — React Native's
 * fetch does not send one automatically, and Better Auth rejects requests
 * without it with "Missing or null Origin". Injecting it globally here means
 * individual hooks never need to hand-roll raw fetch calls just for headers.
 */
const apiOrigin = API_BASE_URL.replace('/api/v1', '');

const nativeFetchImpl: typeof fetch = (input, init) => {
  const expoOrigin = Linking.createURL('', { scheme: 'cbjj' });
  const headers = new Headers((init?.headers as HeadersInit) ?? {});
  if (!headers.has('Origin')) headers.set('Origin', apiOrigin);
  if (!headers.has('expo-origin')) headers.set('expo-origin', expoOrigin);
  if (!headers.has('x-skip-oauth-proxy')) headers.set('x-skip-oauth-proxy', 'true');
  return fetch(input, { ...init, headers });
};

export const authClient = createAuthClient({
  baseURL: NEON_AUTH_URL,
  ...(!isWeb && {
    fetchOptions: {
      customFetchImpl: nativeFetchImpl,
    },
  }),
  plugins: [
    ...(Platform.OS !== 'web'
      ? [
          expoClient({
            scheme: 'cbjj',
            storagePrefix: 'cbjj',
            // Neon Auth issues cookies named `__Secure-neon-auth.session_token`.
            // The expoClient plugin only persists Set-Cookie headers whose name
            // (after stripping `__Secure-`) starts with this prefix, so it must
            // match Neon's actual cookie name — NOT `neonauth`.
            cookiePrefix: 'neon-auth',
            storage: SecureStore,
          }),
        ]
      : []),
  ],
});
